
'use strict';

angular.module('ringbaPortal')
  .filter('current_date', function() {
    return function(epoch) {
      const dt = new Date(epoch);
      dt.setHours(dt.getHours() + 12);
      return dt.getTime();

    };
  })
  .controller('StatsController',
    function(_,
      moment,
      $scope,
      $interval,
      accountsService,
      statsService,
      userSettingsService,
      infoService,
      utils,
      $filter,
      $timeout,
      featureFlags
    ) {
      'ngInject';

      const vm = this;
      let timer;

      vm.dateValues = {
        startDate: null,
        endDate: null,
        currentDate: new Date()
      };

      vm.stat = [];
      vm.past = 0;
      vm.days = 1;
      vm.statsSelected = {};
      vm.$onInit = onInit;
      vm.$onChanges = onChanges;
      vm.getDayDate = getDayDate;
      vm.getDayName = getDayName;
      vm.redrawGraph = redrawGraph;
      vm.getSelectedClass = getSelectedClass;

      vm.statsService = statsService;

      function onInit() {
        _getUserSelectedChartParameters().then(function(dashboardChartConfig) {
          vm.past = (dashboardChartConfig && dashboardChartConfig.day) || 0;
          vm.stat = (dashboardChartConfig && _filterSelectedParamsFeatureFlag(dashboardChartConfig.params)) || _getDefault();
          vm.statsSelected = _getStatsSelectedFromConfig(vm.stat, vm.past);
          vm.statsService.getStatsSum(accountsService.currentAccountId, vm.subId, vm.type);
          return _updateStats();
        }).then(function() {
          _resetInterval();
          vm.stat = angular.copy(vm.stat);
        });
        _loadTimeZones();
      }

      function onChanges(changesObj) {
        if (changesObj && changesObj.subId && !changesObj.subId.isFirstChange() && changesObj.subId.currentValue) {
          vm.statsService.getStatsSum(accountsService.currentAccountId, vm.subId, vm.type).then(function () {
            vm.dateValues.currentDate = new Date();
            _updateStats().then(function () {
              _resetInterval();
              vm.stat = angular.copy(vm.stat);
            });
          });
        }
      }

      $scope.$on('sidebarMinified', redrawGraph);

      $scope.$on('$destroy', function() {
        if (angular.isDefined(timer)) {
          $interval.cancel(timer);
        }
      });

      vm.displayStatsSum  = function (messageType, sum) {
        const messageTypeToFilterMap = {
          'INT': 'number',
          'TIME_IN_SECONDS': 'secondsDisplayFormat',
          'CURRENCY': 'currency'
        };
        const filterName = messageTypeToFilterMap[messageType] || 'number';
        return $filter(filterName)(sum, undefined, 0);
      };

      vm.setStat = function(stat, index) {
        // Tracks selected stats
        _resetInterval();
        if(vm.stat.indexOf(stat) > -1 && vm.past === index) {
          vm.stat = _removeFromStat(vm.stat, stat, index);
          return;
        }
        if (vm.past !== index) {
          vm.statsSelected[vm.past] = undefined;
          vm.past = index;
          _updateStats().then(function() {
            vm.stat = [];
            vm.stat = _addToStat(vm.stat, stat, index);
          });
        } else {
          vm.stat = _addToStat(vm.stat, stat, index);
        }
      };

      function redrawGraph() {
        $timeout(function (){
          angular.forEach(Highcharts.charts, function (value){
            if (value) {
              value.reflow();
            }
          });
        }, 100);
      }

      function getSelectedClass(statSelected) {
        return _.kebabCase(statSelected);
      }

      //TODO Should convert this function to filter
      function getDayDate(day) {
        return moment(day.epoch).utcOffset(day.utc_offset * 60).format('M/D');
      }

      //TODO Should convert this function to filter
      function getDayName(day) {
        return moment(day.epoch).utcOffset(day.utc_offset * 60).format('dddd');
      }

      function _updateStats() {
        return vm.statsService.getRolledUpStats(accountsService.currentAccountId, vm.subId, vm.type, vm.past, vm.days);
      }

      function _removeFromStat(statsArray, stat, day) {
        statsArray = angular.copy(statsArray) || [];
        _.remove(statsArray, function(s) {
          return s === stat;
        });
        vm.statsSelected = _getStatsSelectedFromConfig(statsArray, day);
        _saveUserSelectedStatsParameters(statsArray, day);
        return statsArray;
      }

      function _getDefault(){
        const statsArray = angular.copy(vm.stat) || [];
        statsArray.push('Incoming');
        statsArray.push('Connected');
        statsArray.push('Revenue');
        statsArray.push('Payout');
        vm.statsSelected = _getStatsSelectedFromConfig(statsArray, 0);
        _saveUserSelectedStatsParameters(statsArray, 0);
        return statsArray;
      }

      function _addToStat(statsArray, stat, day) {
        statsArray = angular.copy(statsArray) || [];
        statsArray.push(stat);
        vm.statsSelected = _getStatsSelectedFromConfig(statsArray, day);
        _saveUserSelectedStatsParameters(statsArray, day);
        return statsArray;
      }

      function _getStatsSelectedFromConfig(params, day) {
        if(angular.isArray(params)) {
          const statsSelected = {};
          _.map(params, function (stat) {
            _getModifiedStatsSelected(statsSelected, stat, day);
          }); 
          return statsSelected;
        }
        return {};
      }

      function _getModifiedStatsSelected(statsSelected, stat, day) {
        statsSelected[day] = statsSelected[day] || {};
        statsSelected[day][stat] = true;
        return statsSelected;
      }

      function _resetInterval() {
        if(angular.isDefined(timer)) {
          $interval.cancel(timer);
        }
        timer = $interval(function() {
          _updateStats().then(function() {
            vm.stat = angular.copy(vm.stat);
          });
          vm.statsService.getStatsSum(accountsService.currentAccountId, vm.subId, vm.type)
            .then(function() {
              vm.dateValues.currentDate = new Date();
            });
        }, 15000);
      }

      function _saveUserSelectedStatsParameters(params, day) {
        userSettingsService.getUserSettings().then(function(settings) {
          settings.dashboardChartConfig = settings.dashboardChartConfig || {};
          settings.dashboardChartConfig = {
            params: params,
            day: day
          };
          return userSettingsService.saveUserSettings(settings);
        }); 
      }

      function _getUserSelectedChartParameters() {
        return userSettingsService.getUserSettings().then(function(settings) {
          return settings.dashboardChartConfig;
        });
      }

      function _filterSelectedParamsFeatureFlag(params) {
        return params.filter(function (stat) {
          return statsService.fileMap[stat] &&
            (!statsService.fileMap[stat].featureFlag ||
              (statsService.fileMap[stat].featureFlag && featureFlags.isOn(statsService.fileMap[stat].featureFlag)));
        });
      }

      function _loadTimeZones() {
        infoService.getDisplayTimezone(accountsService.currentAccount.timeZoneId)
          .then(function (response) {
            vm.timezone = response;
          })
          .catch(utils.errorHandler);
      }

      vm.hasSelectedStats = function() {
        return _.some(vm.statsSelected, function(day) {
          return _.some(day, Boolean);
        });
      };

    });
